import addError from '../../../utils/error.jsx';

export function request(id, data) {
    id = parseInt(id, 10);
    
    return {
        type: 'CUSTOMERS_SET_WAGERING_LIMIT',
        data,
        id
    };
}

export function error(id, period, errors) {
    id = parseInt(id, 10);

    addError(errors);

    return {
        type: 'CUSTOMERS_SET_WAGERING_LIMIT_ERROR',
        errors,
        period,
        id
    };
}

export function finish(id, period, customer) {
    return {
        type: 'CUSTOMERS_SET_WAGERING_LIMIT_FINISH',
        customer,
        period,
        id
    };
}
